import { memo } from 'react'
import {
  Box,
  Stack,
  Container,
  Typography,
  Link,
  Tooltip,
  Fade,
} from '@mui/material'
import Image from 'next/image'
import { staticImportIcon, IconName } from '@/root/src/utils/static-import-icon'
import useTrans from '@/hooks/useTrans'

const FooterDesktop = () => {
  const trans = useTrans()

  return (
    <Box className="w-full bg-black/40 py-4 relative z-10">
      <Container>
        <Stack
          justifyContent="space-between"
          alignItems="center"
          className="w-full flex-col sm:flex-row"
        >
          <Stack direction={{ sm: 'column', md: 'row' }} justifyContent="center" alignItems="center" spacing={2}>
            <Typography data-testid="footer-copyright" variant="body2" color="textSecondary">
              © 2023 Renec Foundation. All rights reserved.
            </Typography>
            <Link href="/terms-and-conditions" variant="body2" color="textSecondary">{trans.terms_of_use}</Link>
          </Stack>

          <Stack
            data-testid="social-links-wrapper"
            direction="row"
            justifyContent="end"
            alignItems="center"
            spacing={3}
            className="mt-3 sm:mt-0"
          >
            <Stack>
              <Tooltip
                title={IconName.DISCORD}
                placement="top"
                TransitionComponent={Fade}
              >
                <Link data-testid="social-link-discord" href="https://discord.gg/JNvaFP5QCz" target="_blank" rel="noreferrer">
                  <Image
                    src={staticImportIcon(IconName.DISCORD)}
                    alt={IconName.DISCORD}
                    width={24}
                  />
                </Link>
              </Tooltip>
            </Stack>
            <Stack>
              <Tooltip
                title={IconName.REDDIT}
                placement="top"
                TransitionComponent={Fade}
              >
                <Link data-testid="social-link-reddit" href="https://www.reddit.com/r/renecblockchain/" target="_blank" rel="noreferrer">
                  <Image
                    src={staticImportIcon(IconName.REDDIT)}
                    alt={IconName.REDDIT}
                    width={24}
                  />
                </Link>
              </Tooltip>
            </Stack>
            <Stack>
              <Tooltip
                title={IconName.TWITTER}
                placement="top"
                TransitionComponent={Fade}
              >
                <Link data-testid="social-link-twitter" href="https://twitter.com/NemoSwapDEX" target="_blank" rel="noreferrer">
                  <Image
                    src={staticImportIcon(IconName.TWITTER)}
                    alt={IconName.TWITTER}
                    width={24}
                  />
                </Link>
              </Tooltip>
            </Stack>
            <Stack>
              <Tooltip
                title={IconName.TELEGRAM}
                placement="top"
                TransitionComponent={Fade}
              >
                <Link data-testid="social-link-telegram" href="https://t.me/nemoswapdex" target="_blank" rel="noreferrer">
                  <Image
                    src={staticImportIcon(IconName.TELEGRAM)}
                    alt={IconName.TELEGRAM}
                    width={24}
                  />
                </Link>
              </Tooltip>
            </Stack>
          </Stack>
        </Stack>
      </Container>
    </Box>
  )
}

export default memo(FooterDesktop)
